import URI from 'urijs';
import i18n from 'i18next';

export const fetchOptimalleThemes = () => fetch('/public-api/'+i18n.language+'/optimalle/themes');
export const fetchOptimalleHikes = (slug) => {
    if(slug){
        return fetch('/public-api/'+i18n.language+'/optimalle/themes/' + slug + '/hikes');
    }
    return fetch('/public-api/'+i18n.language+'/optimalle/hikes');
}
export const fetchPromotedOptimalles = () => fetch('/public-api/'+i18n.language+'/optimalles/promoted');

export const fetchOptimalles = (filters, page = 0) => {
    const url = new URI('/public-api/'+i18n.language+'/optimalles');

    Object.keys(filters).map(name => {
        if (null !== filters[name] && '' !== filters[name]) {
            url.addSearch(name, filters[name]);
        }
    });
    url.addSearch('page', page);
    return fetch(url.toString());
}